export default "__VITE_ASSET__EIg1F7fb__"